import { apiPost } from '../api'

export const add_learner = data => {
  return apiPost({
    endpoint: 'groups/add_learners',
    data: data
  })
}
